import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Typography, Link, Grid, TextField, Container, MenuItem, Button, FormControl, FormHelperText } from '@mui/material';
import { isMobileSize } from '../../helpers/functions/functions';

import { loginFrejaIDAction, checkFrejaIDProgress, handleSelectClientAction, resetFrejaIDProgress } from './actions/loginActions';
import { my_ssn_validations } from '../../helpers/functions/functions';

import { Refresh as RefreshIcon } from '@mui/icons-material';

import { Loading, Form } from '../Generic';

import QRCode from 'qrcode.react';

class LoginFrejaID extends Component {
	componentDidMount() {
		this.props.resetFrejaIDProgress();
	}

	state = {
		ssn: '',
		selectedLanguage: this.props.selectedLanguage,
		refreshQrcodeError: false,
	};

	handleSSN = (e) => {
		this.setState({
			ssn: e.target.value,
		});
	};

	handleSubmitButton = (form) => {
		if (typeof this.props.handleSubmitAction !== 'undefined') {
			this.props.handleSubmitAction(form);
		} else {
			this.props.loginFrejaIDAction(form, this.state.selectedLanguage);
		}
	};

	handleDefaultValues = (config) => {
		let values = {};
		config.fields.filter((field) => typeof field.initialvalue !== 'undefined').map((field, i) => (values[field.name] = field.initialvalue));
		return values;
	};

	handleConfig = () => {
		const { translate } = this.props;

		const structure = {
			form: 'frejaid',
			title: '',
			subtitle: '',
			helperText: '',
			button_label: translate('generic_button_sign_in'),
			button_loading_label: translate('login_form_loading_button'),
			fields: [
				{
					id: 'frejaid_ssn',
					name: 'frejaid_ssn',
					label: translate('login_frejaid_field_ssn_placeholder'),
					type: 'number',
					disableNumberArrows: true,
					validate: {
						required: true,
						...(this.props.settings.auth.ssnValidation
							? {
									functionValidation: [
										{
											validation: (value) =>
												typeof my_ssn_validations[this.props.settings.auth.ssnValidation] !== 'undefined'
													? my_ssn_validations[this.props.settings.auth.ssnValidation](value)
													: true,
										},
									],
							  }
							: {}),
					},
				},
				{
					id: 'deviceid',
					name: 'deviceid',
					label: '',
					type: 'hidden',
				},
			],
		};

		let initialValues = this.handleDefaultValues(structure);

		return { structure: structure, initialValues: initialValues };
	};

	render() {
		const { translate } = this.props;
		const configuration = this.handleConfig();

		return this.props.frejaid_progress ? (
			<div>
				<Loading size={50} insideComponent={true} />
				<Typography>{translate('login_frejaid_open_app')}</Typography>
			</div>
		) : (
			<React.Fragment>
				<Grid container>
					<Grid item xs={12} md={12}>
						<Form
							form={configuration.structure.form}
							formData={configuration.structure}
							initialValues={configuration.initialValues}
							handleSubmit={() => this.handleSubmitButton(configuration.structure.form)}
						/>
					</Grid>
					{this.props.type != 'login_meeting' && (
						<Grid item xs={12} md={12}>
							<Link
								href="#"
								variant="body2"
								onClick={() => {
									this.props.handleSelectClientAction(null, null);
								}}
							>
								&crarr; {translate('login_form_back_to_client_selection')}
							</Link>
						</Grid>
					)}
				</Grid>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	frejaid_progress: state.login.frejaid_progress,
	autostarttoken: state.login.autostarttoken,
	login: state.login,
	translate: getTranslate(state.localize),
	settings: state.settings,
	client: state.login.client,
});

export default connect(mapStateToProps, {
	loginFrejaIDAction,
	checkFrejaIDProgress,
	handleSelectClientAction,
	resetFrejaIDProgress,
})(LoginFrejaID);
